
    import {
      getAllLocations,
      createLocation,
      createAllLocations,
      updateLocation,
      deleteLocation
    } from "@/services/location";

    const state = {
      locations: [],
      processed: false
    };

    const getters = {
      getLocations(state) {
        return state.locations;
      },
      locationProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      fetchLocations({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllLocations(
              params
            )
              .then(response => {
                commit("SET_LOCATIONS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createLocation({ commit }, location) {
          return new Promise((resolve, reject) => {
            createLocation(location)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllLocations({ commit }, locations) {
          return new Promise((resolve, reject) => {
            createAllLocations(locations)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateLocation({ commit }, location) {
          return new Promise((resolve, reject) => {
            updateLocation(location)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteLocation({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteLocation(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_LOCATIONS(state, data) {
        state.locations = data;
        state.processed = true;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    